import store from "@/store";
import {
  Module,
  VuexModule,
  MutationAction,
  getModule,
  Action,
  Mutation,
} from "vuex-module-decorators";
import API from "@/store/api/mmc_staff";
import {
  MMCMembersStaff,
  PaginatedMmcMemberStaff,
  MMCMembersStaffFilter,
} from "../model/mmc_staff";
import { QTablePagination } from "../model/page";

@Module({ name: "MMCMembersStaffStore", dynamic: true, store })
class MMCMembersStaffModule extends VuexModule {
  public MMCMemberStaffList: MMCMembersStaff[] = [];
  public SingleMMCMemberStaff: MMCMembersStaff = {} as MMCMembersStaff;
  public PaginatedMMCMemberStaff: PaginatedMmcMemberStaff =
    {} as PaginatedMmcMemberStaff;
  public QTablePaginationData: QTablePagination = {
    sortBy: "id",
    descending: false,
    page: 1,
    rowsPerPage: 10,
    rowsNumber: 1,
  };
  @Mutation
  setMmcMemberStaff(data: MMCMembersStaff) {
    this.SingleMMCMemberStaff = data;
  }

  @Mutation
  setMmcStaffPagination(data: QTablePagination) {
    this.QTablePaginationData = data;
  }

  @MutationAction
  async getMMCMemberStaffList(
    params: {
      searchString?: any;
      market_id?: any;
    } = { searchString: undefined }
  ): Promise<any> {
    let query = "";
    if (params.searchString || params.market_id) {
      query += "?";
      if (params.searchString) {
        query += "&search=" + params.searchString;
      }
      if (params.market_id) {
        query += "&market=" + params.market_id;
      }
    }
    const response = await API.getMmcStaffList(query);
    console.log(response);
    return { MMCMemberStaffList: response };
  }
  @MutationAction
  async getPaginatedMMCMembersStaff(
    params: MMCMembersStaffFilter = { search: "", page: 1 }
  ): Promise<any> {
    let query = "";
    if (params.search || params.page || params.market) {
      query += "?";
      if (params.search) {
        query += "&search=" + params.search;
      }
      if (params.page) {
        query += "&page=" + params.page;
      }
      if (params.market) {
        query += "&market=" + params.market;
      }
    }
    const response = await API.getPaginatedMmcStaff(query);
    console.log(response);
    return { PaginatedMMCMemberStaff: response };
  }
  @Action
  async createMMCMemberStaff(params: { data: FormData }): Promise<any> {
    const response = await API.createMmcStaff(params.data);
    return response;
  }

  @Action
  async editMMCMemberStaff(params: {
    data: FormData;
    id: number;
  }): Promise<any> {
    const response = await API.editMmcStaff(params.data, params.id);
    return response;
  }

  @MutationAction
  async getMMCMemberStaffById(id: any): Promise<any> {
    const response = await API.getMmcStaffById(id);
    return { SingleMMCMemberStaff: response };
  }
  @Action
  async deleteMmcStaffById(params: { id: number }): Promise<any> {
    const response = await API.deleteMmcStaff(params.id);
    return response;
  }
}

export default getModule(MMCMembersStaffModule);
